import { useMemo } from 'react';
import { useQuery } from 'react-query';
import * as api from '../../services/api';
import useAccount from './useAccount';
import useCanAccessOrgDashboard from './useCanAccessOrgDashboard';

const useOrgContracts = () => {
  const { accountId } = useAccount();
  const canAccess = useCanAccessOrgDashboard();

  const storeKey = useMemo(() => ['orgContracts', accountId], [accountId]);

  const { isLoading, data } = useQuery(storeKey, () => api.fetchOrgContracts({ accountId }), {
    enabled: !!accountId && canAccess
  });

  const orgContracts = useMemo(() => data?.data || [], [data?.data]);
  const orgContractsOptions = useMemo(
    () => orgContracts.map(({ id, name, contractId }) => ({ value: id, label: `${name} (${contractId})` })),
    [orgContracts]
  );

  return { isLoading, orgContracts, orgContractsOptions };
};

export default useOrgContracts;
